export default __webpack_public_path__ + "static/media/logo-facebook.4a455df5.png";